import { Navigate } from "react-router-dom";
// hooks
import { PropsWithChildren, ReactElement } from "react";
import useAuth from "@callveriq/hooks/useAuth";
import { DashboardRoutesConfig } from "@callveriq/config/routes.config";

const conversationRoute = DashboardRoutesConfig.Conversations;

// const homeRoute = DashboardRoutesConfig.Home;

export default function GuestGuard({
    children,
}: PropsWithChildren): ReactElement {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to={conversationRoute.to} />;
    }

    return <>{children}</>;
}
